function updateHeaderCartCount(itemCount) {
  document.querySelectorAll(".m-cart-count-bubble").forEach((bubble) => {
    if (itemCount > 0) {
      bubble.textContent = itemCount;
      bubble.classList.remove("m:hidden");
    } else {
      bubble.textContent = "0";
      bubble.classList.add("m:hidden");
    }
  });

  document.querySelectorAll(".m-cart-icon-bubble").forEach((link) => {
    link.setAttribute(
      "aria-label",
      `Cart with ${itemCount} ${itemCount === 1 ? "item" : "items"}`,
    );
  });
}

document.addEventListener("click", async (event) => {
  const btn = event.target.closest(".as-add-to-cart");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  if (btn.classList.contains("is-loading")) return;

  btn.classList.add("is-loading");
  btn.disabled = true;

  try {
    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    if (!addResponse.ok) throw new Error("Add to cart failed");

    const cartResponse = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
    });

    const cart = await cartResponse.json();

    updateHeaderCartCount(cart.item_count);

    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.emit(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        cart,
      );
    }

    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
    document.dispatchEvent(new CustomEvent("cart:opened", { detail: cart }));
  } catch (e) {
    console.error(e);
  } finally {
    btn.classList.remove("is-loading");
    btn.disabled = false;
  }
});
